import ReportStatisticCard from "@/admin/insights/member-reports/common/MemberReportStatisticCard"
import { MemberReportProductEventsAttendanceRateStatisticCardFragment$key } from "@/admin/insights/member-reports/common/__generated__/MemberReportProductEventsAttendanceRateStatisticCardFragment.graphql"
import { useLabels } from "@/core/context/LabelsContext"
import { graphql, useFragment } from "react-relay"

interface Props {
  organizationMembershipKey: MemberReportProductEventsAttendanceRateStatisticCardFragment$key
}

export default function MemberReportProductEventsAttendanceRateStatisticCard({
  organizationMembershipKey,
}: Props) {
  const labels = useLabels()
  const organizationMembership =
    useFragment<MemberReportProductEventsAttendanceRateStatisticCardFragment$key>(
      graphql`
        fragment MemberReportProductEventsAttendanceRateStatisticCardFragment on OrganizationMembership
        @argumentDefinitions(startDate: { type: "String" }) {
          eventsAttendanceRateReport(startDate: $startDate, productLevel: true) {
            allTime
          }
        }
      `,
      organizationMembershipKey
    )

  return (
    <ReportStatisticCard
      testid={"MemberReportProductEventsAttendanceRateStatisticCard"}
      value={`${organizationMembership.eventsAttendanceRateReport?.allTime || 0}%`}
      subtitle={`Event Attendance Rate`}
      tooltip={`This rate shows this ${labels.admin_member.singular}'s attendance for all available events across ${labels.admin_experience.plural}.`}
    />
  )
}
